'use strict';

exports.__esModule = true;
exports.TrackEvent = TrackEvent;
exports.TrackPageview = TrackPageview;
//事件跟踪 params: whereId-页面或按钮Id-string-必须  whoId-用户hashId-string-必须  label-whereId的简单描述-string-选填  typeId-按钮或页面-int-选填
//还有最后一个未用的参数：nodeId-string-选填
function TrackEvent(params) {
    _czc.push(['_trackEvent', params.label ? params.label : '', params.whoId, params.whereId, params.typeId ? params.typeId : null]);
}

//页面PV统计 pathname:当前页面的this.props.location.pathname
function TrackPageview(pathname) {
    if (pathname.indexOf("/wx/pay/register") === -1) {
        _czc.push(["_trackPageview", pathname, window.location.origin]);
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/ui/component/common/CNZZ.js
// module id = 559
// module chunks = 0